import { ReactNode } from 'react';
import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { CameraOutlineIc, CloseOutlineIc } from '@dsch/dd-icons';
interface GalleryHeaderProps {
  className?: string;
  currentCountPosition: number;
  totalMedia: number;
  askToClose: () => void;
  renderShareAd?: ReactNode;
  renderSaveAd?: ReactNode;
  renderShareMedia?: ReactNode;
  renderCounter?: (index: number, total: number) => ReactNode;
}

const Header = styled.header`
  padding: ${({ theme }) => `${theme.spacing.S12} ${theme.spacing.M16}`};
  // TODO: Chat to design about rgba values of our colours
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Close = styled.span`
  color: ${({ theme }) => theme.colors.GREY_DARK};
  cursor: pointer;
  flex: 1;
  text-align: right;
`;

const Count = styled.div`
  ${({ theme }) => theme.fontSize.L18};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  justify-content: center;
  flex: 2;

  .camera-icon {
    color: ${({ theme }) => theme.colors.GREY_DARKER};
    margin-right: ${({ theme }) => theme.spacing.S8};
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const ShareAdWrapper = styled.div`
  ${media.medium} {
    margin-right: ${({ theme }) => theme.spacing.M24};
    margin-left: ${({ theme }) => theme.spacing.M16};
  }
`;

function GalleryHeader({
  className,
  currentCountPosition,
  totalMedia,
  askToClose,
  renderShareMedia,
  renderShareAd,
  renderSaveAd,
  renderCounter,
}: GalleryHeaderProps) {
  return (
    <Header className={className}>
      <Actions>
        {renderShareMedia}
        <ShareAdWrapper>{renderShareAd}</ShareAdWrapper>
        {renderSaveAd}
      </Actions>
      <Count>
        <CameraOutlineIc className="camera-icon" />
        {renderCounter
          ? renderCounter(currentCountPosition, totalMedia)
          : `${currentCountPosition} / ${totalMedia}`}
      </Count>
      <Close data-testid="gallery-close" onClick={askToClose}>
        <CloseOutlineIc width="24" height="24" />
      </Close>
    </Header>
  );
}

export { GalleryHeader };
